export const teal50 = "#E8F7F4";
export const teal100 = "#D6F4F0";
export const teal200 = "#ADEAE2";
export const teal300 = "#84DFD3";
export const teal400 = "#5BD5C5";
export const teal500 = "#33CBB7";
export const teal600 = "#28BBAD";
export const teal700 = "#1EAAA5";
export const teal800 = "#149A9B";
export const teal900 = "#0A8A92";
export const teal1000 = "#026D68";
export const tealA100 = "#5BF4F0";
export const tealA200 = "#4CE5DB";
export const tealA400 = "#19B193";
export const tealA500 = "#048759";
export const tealA1000 = "#11463F";
